import {
  Attribute,
  BelongsTo,
  JsonApiModel,
  JsonApiModelConfig,
} from '@elearnio/angular2-jsonapi';

import { Member } from '@models/member.model';

/**
 * One attempt at a task. The BE writes a row per learner submit and updates that
 * same row when a reviewer grades it, so `reviewedAt` and `reviewer` are only set
 * once the attempt has been reviewed.
 *
 * `content` carries the same xAPI payload shape as CourseMemberAnswer.content.
 */
@JsonApiModelConfig({
  type: 'task_submissions',
})
export class TaskSubmission extends JsonApiModel {
  @BelongsTo()
  reviewer: Member | undefined;

  @Attribute()
  content!: string;

  @Attribute({ serializedName: 'created_at' })
  createdAt!: Date;

  @Attribute({ serializedName: 'reviewed_at' })
  reviewedAt!: Date | null;
}
